import { Stack } from '@mui/material';
import { useEffect } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { useQuery } from 'react-query';
import { listProgramWithMetadata } from '../../../api/program';
import { useClientAuth } from '../../../providers/ClientProvider';
import { BinService } from '../../apis';
import { EditFormFiled } from '../../../components/common/deprecated/EditFormFiled';

interface IProps {
  divisionId?: string;
}
function SelectProgramAndBin({ divisionId }: IProps) {
  const { clientId } = useClientAuth();

  const hookForm = useFormContext<{
    binId: string;
    programId: string;
  }>();
  const binId = hookForm.watch('binId');
  const programId = hookForm.watch('programId');

  const listProgramsForEntity = useQuery({
    queryKey: ['list_programs_for_entity', divisionId, clientId],
    queryFn: () => {
      return listProgramWithMetadata({
        metaDataDto: {
          clientId: clientId || '',
          divisionId: divisionId || '',
        },
        page: 0,
        size: 100,
      });
    },
    enabled: !!divisionId && !!clientId,
    select(data) {
      return data.data.records.map((program) => ({
        value: program.programId + '',
        label: program.name || '',
      }));
    },
  });

  const listBinProgramsQuery = useQuery({
    queryKey: ['list_bin_programs', programId, clientId],
    queryFn: () => {
      return BinService.listBinProgram({
        // binId: binId,
        programId: programId,
        clientId: clientId || '',
        populateBin: true,
      });
    },
    enabled: !!programId && !!clientId,
    select(data) {
      return data.records.map((programBin) => ({
        value: programBin.binDto.id + '',
        label: programBin.binDto?.binValue || '',
      }));
    },
  });

  useEffect(() => {
    hookForm.setValue('programId', '');
    hookForm.setValue('binId', '');
  }, [divisionId]);

  return (
    <Stack spacing={2}>
      <Controller
        name="programId"
        control={hookForm.control}
        rules={{ required: true }}
        render={({ field }) => (
          <EditFormFiled
            title={'SELECT PROGRAM '}
            description={field.value}
            {...field}
            placeHolder={'Select Program '}
            onChange={(val) => {
              field.onChange(val);
              hookForm.setValue('binId', '');
            }}
            options={[
              // {
              //   value: '',
              //   label: 'Select None',
              // },
              ...(listProgramsForEntity.data || []),
            ]}
          />
        )}
      />
      {programId && (
        <Controller
          name="binId"
          control={hookForm.control}
          rules={{ required: true }}
          render={({ field }) => (
            <EditFormFiled
              title={'SELECT BIN '}
              description={field.value}
              onChange={(val) => {
                field.onChange(val);
                // hookForm.setValue('programId', '');
              }}
              placeHolder={'Select Bin Value '}
              options={listBinProgramsQuery.data || []}
            />
          )}
        />
      )}
    </Stack>
  );
}

export default SelectProgramAndBin;
